import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import eventApi from "../../api/Eventapi";
import { useNavigate } from "react-router";


const Event_card = () => {
  const[events , setEvents] = useState([]);
  const navigate = useNavigate();


useEffect(() => {
    eventApi.getAll()
      .then((res) => setEvents(res))
      .catch((err) => console.error('Error fetching events', err));
}, []);

  const getTextPreview = (html, length = 60) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text.length > length ? text.slice(0, length) + "..." : text;
  };




  return (
    <Container>
      {/* First Row */}
      <Row className="mb-4" style={{ gap:"0rem" }}>
        {/* Event 1 */}

          {events . map((event) => (
            <Col lg={4} md={6} sm={12}>
          <div className="event-card">
            <div className="event-card-image">
              <img
                src={event.featured_image}
                alt={event.title}
              />
            </div>
            <div className="event-card-content">
              <div className="event-card-meta">
                <span className="event-type">{event.category}</span>
                <span className="event-date">
                  {new Date(event.created_at).toISOString().split('T')[0].split('-').reverse().join('-')}
                </span>
              </div>
              <h3 className="event-title">{event.title}</h3>
              <p>
              {getTextPreview(event.description, 130)}
              </p>
             

               <div className="buttonss-container-1" style={{ marginLeft: "-0.5rem" }}>
                                <span className="mass">Read More</span>
                                <button  id="work" type="button"  name="Hover" style={{  background: "linear-gradient(45deg, #002266, #000436)",  color: "white", borderRadius: "9px",  border: "none", cursor: "pointer", height: "5rem" , width: "10rem"  }} onClick={() => navigate(`/events/${event.slug}`)}>
                                  Read More
                                </button>
                              </div>
            </div>
          </div>
        </Col>
          
          ))}
        

        
      </Row>
    </Container>
  );
};

export default Event_card;
